import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-post-type-helper-modal',
  templateUrl: './post-type-helper-modal.component.html',
  styleUrls: ['./post-type-helper-modal.component.scss'],
  standalone: false
})
export class PostTypeHelperModalComponent implements OnInit {

  @Input() hasWordpressTarget: boolean = false;
  @Input() selectedDate?: string; // Optional ISO string

  step: number = 1;
  maxStep: number = 2;
  path: 'photo' | 'link' | null = null;

  // Form data for link path
  url: string = '';
  directions: string = 'Summarize and comment positively';
  maxParagraphs: number = 5;
  tone: string = 'objective';
  account: any;

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.account = this.accountService.getActiveAccount();
    if (this.account?.defaultTone) {
      this.tone = this.account.defaultTone;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  setStep(s: number) {
    this.step = s;
    if (s === 1) {
        this.path = null;
    }
  }

  async selectType(type: string) {
    // Dismiss modal first
    const queryParams: any = {};
    if (this.selectedDate) {
      queryParams.date = this.selectedDate;
    }
    
    switch (type) {
        case 'wordpress':
            await this.modalCtrl.dismiss();
            this.router.navigate(['/post-wordpress-new'], { queryParams });
            break;
        case 'photo_step':
            this.path = 'photo';
            this.step = 2;
            break;
        case 'link':
            this.path = 'link';
            this.step = 2;
            break;
        case 'social-card':
            await this.modalCtrl.dismiss();
            queryParams.postType = 'social-card';
            this.router.navigate(['/post-new'], { queryParams });
            break;
        case 'photo':
            await this.modalCtrl.dismiss(); // User selected 'No' in step 2 (plain photo)
            queryParams.postType = 'photo';
            this.router.navigate(['/post-new'], { queryParams });
            break;
        case 'text':
            await this.modalCtrl.dismiss();
            queryParams.postType = 'text';
            this.router.navigate(['/post-new'], { queryParams });
            break;
    }
  }

  async submitLink() {
     if (!this.url) return;

     await this.modalCtrl.dismiss();
     
     const queryParams: any = {
         postType: 'text', 
         mode: 'link',
         url: this.url,
         directions: this.directions,
         maxParagraphs: this.maxParagraphs,
         tone: this.tone
     };
     
     if (this.selectedDate) {
       queryParams.date = this.selectedDate;
     }

     this.router.navigate(['/post-new'], { queryParams });
  }

}
